import React, { useState, useEffect, useMemo, useContext } from 'react';
import PropTypes from 'prop-types';
// import { logout } from '../utils/common';

// Contexts
import { ProductContext } from '../contexts/ProductContext';
import { AuthContext } from '../contexts/AuthContext';
import { getProductStatus } from '../services/pgConfig';

export const ProductProvider = ({ children }) => {
  const { env, userObj } = useContext(AuthContext);
  const [isProductStatusFetched, setIsProductStatusFetched] = useState(false);
  const [productsStatus, setProductsStatus] = useState();

  const populateProductStatus = async productStatuses => {
    setProductsStatus({ ...productStatuses });
    setIsProductStatusFetched(true);
  };
  const fetchProductStatus = async () => {
    if (userObj?.cfToken?.[env]) {
      const { token } = userObj.cfToken[env];

      const response = await getProductStatus(token);
      await populateProductStatus(response);
    } else if (window.location.hostname !== 'localhost') {
      // logout();
    } else {
      // userObj.logout();
    }
  };

  useEffect(() => {
    if (!isProductStatusFetched) {
      fetchProductStatus();
    }
  }, [isProductStatusFetched]);

  const value = useMemo(
    () => ({
      isProductStatusFetched,
      productsStatus,
      populateProductStatus,
    }),
    [isProductStatusFetched, productsStatus],
  );

  return (
    <ProductContext.Provider value={value}>{children}</ProductContext.Provider>
  );
};

ProductProvider.propTypes = {
  children: PropTypes.any,
};
